import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders, HttpParams } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import {environment} from '../../environments/environment';

import * as $ from 'jquery';

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css']
})
export class FormularioComponent implements OnInit {

    /* Configurações do serviço e do Google Captcha */
    urlServico:string = environment.URL_SERVICO;
    chaveServico:string = environment.CHAVE_SERVICO;
	googleCaptchaKey:string = environment.GOOGLE_RECAPTCHA_SITE_KEY;
	urlPortalRH:string = environment.URL_PORTALRH;
    /****************************************************** */

	mostraMensagemErro: boolean = false;
	mostraMensagemErroSistema: boolean = false;
	mostraMensagemOk: boolean = false;
	token: string;
	captcha: any;

	loading: boolean = false;
	//cpf: string;

	camposForm: any = [
		{nome: 'Matricula', label:'Matrícula', dica:'(somente números, sem pontos ou traços)'},
		{nome: 'DiaNascimento', label:'Dia do Nascimento', dica:'Ex.: 05'},
		{nome: 'MesNascimento', label:'Mês do Nascimento', dica:'Ex.: 09'},
		{nome: 'AnoNascimento', label:'Ano do Nascimento', dica:'Ex.: 1960'},
		{nome: 'UltimoNomeDaMae', label:'Último Nome da Mãe', dica:''}
	]

	camposFormSorteados: any = [];

	total_sorteios: number = 3;
	numero_sorteado: number;
	item_sorteado: any;
	numbers: any[] = [];
	@ViewChild('form') form: HTMLElement;

	ngOnInit() {

		this.camposFormSorteados = [];
		this.camposFormSorteados.push({nome: 'CPF', label:'Cpf', dica:'(somente números, sem pontos ou traços)'});

		this.numero_sorteado = this.getRandomNumber(0,this.camposForm.length-1 );
		for(var i = 1; i <= this.total_sorteios; i++){

				while (this.numbers.indexOf(this.numero_sorteado) > -1) {
						this.numero_sorteado = this.getRandomNumber(0,this.camposForm.length-1 );
				}
				this.numbers.push(this.numero_sorteado);
				this.item_sorteado = this.camposForm[this.numero_sorteado];
				this.camposFormSorteados.push(this.item_sorteado);
		}
		
	}

	constructor(
		private _http: HttpClient, 
		private router: Router
        ) {
		}
        
	mostraFormulario() {

        this.mostraMensagemErro = false;
        this.mostraMensagemErroSistema = false;
        this.mostraMensagemOk = false;
		this.captcha = undefined;
	}

	onSubmit(form) {

            this.loading=true;
		
			setTimeout(()=>{

				if (this.captcha==undefined) {
					this.mostraMensagemErro=true;
				}
	
				let dados = 'CPF='+form.value['CPF'];
				this.camposForm.forEach(element => {
	
					if (form.value[element['nome']]!=undefined) {
						dados += '&'+element['nome']+'='+form.value[element['nome']];
					} else {
						dados += '&'+element['nome']+'=';
					}
			
                });               

				dados += '&Chave='+this.chaveServico;
	
				this.servico(dados);
	
			},2000);


	}

	servico(dados) {

            const service = this.urlServico;

			const headers = new HttpHeaders()
			.set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/xml');
		
            const options = {headers, responseType: 'text' as 'text', 
                                        rejectUnauthorized: false,
                                        requestCert: false,
                                        agent: false};

            let token = '';
            
			this._http.post(service, dados,  options )
				.subscribe(data => {

					let xml = $.parseXML(data);
					
					let token = $(xml).find("string")[0].textContent;

					this.loading = false;

					if (token!='' && token!='undefined') {
							this.mostraMensagemOk = true;
							this.token = token;
					}else{
							this.mostraMensagemErro = true;
					}}, err => {
							this.loading = false;
							this.mostraMensagemErroSistema = true;


					}

			);


	}

	getPortalRH() {
		return  this.urlPortalRH + "?id="+this.token;
	}
	
	getRandomNumber(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}
			
	setCaptcha(captchaResponse: string) {
		this.captcha = captchaResponse;
	}
			
}




// WEBPACK FOOTER //
// D:/contracheque-inativos/src/app/formulario/formulario.component.ts